<template>
  <section class="location new-report__section">
    <h3 class="new-report__heading">LOCATION WHERE DEAD/SICK DEER SIGHTED</h3>
    <div class="new-report__input-row">
      <label class="new-report__label" for="county"
        >County <span class="new-report__required-marker">*</span>
      </label>
      <multiselect
        id="county"
        :options="countyOptions"
        :value="county"
        :placeholder="'-- Please Select --'"
        name="county"
        class="new-report__input new-report__input--select"
        required=""
        @input="updateCounty"
      />
    </div>
    <div class="new-report__input-row">
      <label class="new-report__label" for="loc-details"
        >Location Details</label
      >
      <textarea
        id="loc-details"
        :value="locDetails"
        name="locDetails"
        placeholder="(address or crossroads)"
        class="new-report__input new-report__input--textarea"
        @change="debounceLocationDetails"
        @blur="updateLocationDetails"
      ></textarea>
    </div>
  </section>
</template>

<script>
import counties from "~/components/Reports/counties";
import Multiselect from "vue-multiselect";
import { mapMutations } from "vuex";
import { debounce } from "lodash";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      countyOptions: counties,
    };
  },
  computed: {
    county() {
      return this.$store.state.incidentReport.location.county;
    },
    locDetails() {
      return this.$store.state.incidentReport.location.details;
    },
  },
  methods: {
    updateCounty(event) {
      const location = this.$store.state.incidentReport.location;
      const county = event;
      location.county = county;
      this.$store.commit("incidentReport/setLocation", location);
    },
    updateLocationDetails(event) {
      const location = $nuxt.$store.state.incidentReport.location;
      const details = event.target.value;
      location.details = details;
      $nuxt.$store.commit("incidentReport/setLocation", location);
    },
    debounceLocationDetails: debounce((event) => {
      const location = $nuxt.$store.state.incidentReport.location;
      const details = event.target.value;
      location.details = details;
      $nuxt.$store.commit("incidentReport/setLocation", location);
    }, 300),
  },
};
</script>

<style lang="scss">
.multiselect {
  &__tags {
    border-color: black;
  }
  &__input {
    &::placeholder {
      color: get-color("grey", 400);
    }
  }
}
</style>
